import * as activeX from './native';

import { fireEvent } from "../events";
import { showConfigurationPopup, hideConfigurationPopup, showBrowserInfoMessage } from "../modal";

const browserSettings = {};

function getBrowserConfiguration () {
    if (Object.keys(browserSettings).length === 0) {
        const config = {};
        config.timezone = activeX.checkTimeZone();
        config.trustedSites = activeX.checkIsabelDomainStatus();
        Object.assign(browserSettings, config);
    }
    return browserSettings;
}

export function checkBrowserSettings () {
    const config = getBrowserConfiguration();
    if(config.timezone == 0){
        fireEvent('invalidDate');
        return false;
    } else  if(config.trustedSites == 0){
        fireEvent('trustedSites');
        return false;
    }
    return true;
}